import { lightTheme } from "@/customTheme";
import * as React from "react";
const SVGComponent = (props) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 4C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6C2 4.89543 2.89543 4 4 4H20ZM4 18H20V10.0439L12.6143 15.7891C12.2532 16.0699 11.7478 16.0699 11.3867 15.7891L4 10.043V18ZM4 7.51074L12.001 13.7334L20 7.51172V6H4V7.51074Z"
      fill={lightTheme.colors.blackGray}
    />
  </svg>
);
export default SVGComponent;
